// City name -> representative Unsplash image (medical-tourism landing imagery).
const U = (id) =>
  `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200`;

const GENERIC = [
  U("1776967906098-f8812e43cf73"),
  U("1680344427682-ccb4e98a4d0b"),
  U("1776439402786-56123ed15900"),
  U("1776967905624-feda3f735379"),
  U("1667317332530-ab236f824894"),
];

const MAP = {
  Mumbai: U("1569758267239-d08deb78bb1a"),
  Delhi: U("1587474260584-136574528ed5"),
  "New Delhi": U("1587474260584-136574528ed5"),
  Chennai: U("1654366758812-2163c2a24ac8"),
  Bangalore: U("1723137855145-5e75dbb402db"),
  Bengaluru: U("1723137855145-5e75dbb402db"),
  Hyderabad: U("1589820745312-e04227bf8843"),
  Kolkata: U("1677307816181-1446ab18913e"),
  Jaipur: U("1603262110263-fb0112e7cc33"),
  Kochi: U("1655266331940-a815d3777da9"),
  Thiruvananthapuram: U("1667317332530-ab236f824894"),
};

export const INDIA_HERO = U("1733094151451-4222a842cfd1");

export function cityImage(name) {
  if (MAP[name]) return MAP[name];
  let h = 0;
  for (let i = 0; i < (name || "").length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return GENERIC[h % GENERIC.length];
}
